module.exports = "<psm-json-editor (jsonChanged)=\"updateConfig($event)\" [json]=\"content\"></psm-json-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/header/header.widget.html
// module id = ./src/app/views/presentations/widgets/header/header.widget.html
// module chunks = main